<div [class.invalid]="groupControl.getError('required') && groupControl.touched" class="btn-group">
    <div *ngFor="let ele of elements">
        <app-custom-btn
            [name]="ele.name"
            [active]="selectedValues.includes(ele.value)"
            (activeChange)="toggleBtn(ele.value)"
        ></app-custom-btn>
    </div>
</div>
